<div *ngIf="!isHidden" class="flex center banner grey-banner">
  <div class="item text">
    <mat-icon>notification_important</mat-icon>
    {{bannerText}}
  </div>
  <button mat-button (click)="hideBanner()" class="item">
    <mat-icon>close</mat-icon>
  </button>
</div>